import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=1d81e2c0&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d81e2c0')) {
      api.createRecord('1d81e2c0', component.options)
    } else {
      api.reload('1d81e2c0', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=1d81e2c0&", function () {
      api.rerender('1d81e2c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard.vue"
export default component.exports